import type { ComponentType } from "react"
import type { CogoElement } from "./types"

export interface RendererProps {
  element: CogoElement
  children?: React.ReactNode
}

export type ElementRenderer = ComponentType<RendererProps>

export class ElementRegistry {
  private renderers = new Map<string, ElementRenderer>()

  register(type: string, renderer: ElementRenderer): void {
    this.renderers.set(type, renderer)
  }

  get(type: string): ElementRenderer | null {
    return this.renderers.get(type) ?? null
  }

  types(): string[] {
    return Array.from(this.renderers.keys())
  }
}

// Singleton instance
export const globalRegistry = new ElementRegistry()
